import dayjs from 'dayjs'
import { formatDate } from 'src/variable/constant'

const MAX_CELL_TEXT = 80

export const USER_LIST_API_FIELDS = [
	'id',
	'name',
	'email',
	'phone',
	'avatar',
	'address',
	'address_local',
	'invite_code',
	'version',
	'blocked_at',
	'unblocked_at',
	'is_verified',
	'is_regular',
	'created_at',
	'deleted_at',
]

const truncateText = (value: unknown, max = MAX_CELL_TEXT) => {
	const text = value == null ? '' : String(value).trim()
	if (!text) {
		return ''
	}
	return text.length > max ? `${text.slice(0, max)}…` : text
}

const formatRowDate = (value: unknown) => {
	if (value == null || value === '') {
		return null
	}

	const parsed = dayjs(value as string | number)
	return parsed.isValid() ? parsed.format(formatDate) : null
}

/** Row shape for Users table — subset of API $all, safe for iPad setData */
export type UserTableRow = {
	no: number
	id: string
	avatar: string
	phone: string
	email: string
	name: string
	address: string
	address_local: string
	invite_code: string
	version: string | null
	blocked_at: unknown
	unblocked_at: unknown
	is_verified: boolean
	is_regular: boolean
	created_at: string
	deleted_at: string | null
}

/** Chỉ giữ field table cần — tránh spread $all (nested objects) gây crash iPad khi setData */
export const mapUserListRows = (
	rows: unknown[] | null | undefined,
	page: number,
	pageSize: number,
): UserTableRow[] =>
	(rows ?? []).map((item: any, index) => ({
		no: index + 1 + pageSize * (page - 1),
		id: String(item?.id ?? ''),
		avatar: truncateText(item?.avatar, 512),
		phone: truncateText(item?.phone),
		email: truncateText(item?.email),
		name: truncateText(item?.name),
		address: truncateText(item?.address),
		address_local: truncateText(item?.address_local),
		invite_code: truncateText(item?.invite_code, 32),
		version: item?.version != null ? truncateText(item.version, 32) : null,
		blocked_at: item?.blocked_at ?? null,
		unblocked_at: item?.unblocked_at ?? null,
		is_verified: !!item?.is_verified,
		is_regular: !!item?.is_regular,
		created_at: formatRowDate(item?.created_at) ?? '',
		deleted_at: formatRowDate(item?.deleted_at),
	}))
